import { useEffect } from "react";
import { PlusIcon } from "lucide-react";
import { useNavigate } from "react-router";

import {
  Column,
  ErrorText,
  LoadingIndicator,
  TopbarContainer,
  TopbarTitle,
} from "@/components";
import { DemoConfigsTable } from "@/components/tools/DemoConfigsTable";
import { Button } from "@/components/ui/button";

import { useSetTitle } from "@/hooks/useSetTitle";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS, MIXPANEL_SUBSCREENS } from "@/lib/mixpanel/types";
import { novaClient } from "@/lib/trpc";
import { DemoConfig } from "@/types";

export const ToolsDemoConfigsListPage = () => {
  const navigate = useNavigate();

  const { data: demoConfigs, status } =
    novaClient.internal.admin.demoConfigs.findAll.useQuery();

  useSetTitle({
    title: "Tools | Demo Configs",
  });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.DEMO_CONFIGS, {
      subScreenName: MIXPANEL_SUBSCREENS.LIST,
    });
  }, []);

  return (
    <Column className="h-svh">
      <TopbarContainer>
        <TopbarTitle>Demo Configs</TopbarTitle>
        <Button
          className="rounded-full"
          onClick={() => {
            mixpanelUtils.trackButtonClick(
              "Create demo config",
              MIXPANEL_SCREENS.DEMO_CONFIGS,
            );
            void navigate("/tools/demo-configs/create");
          }}
        >
          <PlusIcon className="h-4 w-4" />
          Create demo config
        </Button>
      </TopbarContainer>
      <Column className="flex-1 overflow-hidden p-6">
        {status === "pending" && <LoadingIndicator variant="medium" />}
        {status === "error" && (
          <ErrorText errorMessage="Error loading demo configs." />
        )}
        {status === "success" && (
          <DemoConfigsTable demoConfigs={demoConfigs as DemoConfig[]} />
        )}
      </Column>
    </Column>
  );
};
